import { KontentBrandColor } from "../types/index";

export function getColor(kontentColor: { value: KontentBrandColor[] }) {
  if (kontentColor?.value[0]?.elements?.hex_value?.value) {
    return "#" + kontentColor?.value[0]?.elements?.hex_value?.value;
  }

  return undefined;
}

export const brandColors = {
  navy: "#002d3f",
  red: "#fc4f38",
  gold: "#d8ab50",
  turquoise: "#9ee6e8",
  darkgray: "#666666",
  lightgray: "#ededed",
  medgray: "#939393",
  darkred: "#a81607",
  darkgold: "#966517",
  darkturquoise: "#049da5",
  white: "#ffffff",
};
